var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewEmptyTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    transform: "translate(0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 7.3385L15.5024 23.5168L9.49575 17.5102L11.4933 15.5127L15.5024 19.5218L29.6691 5.35516L31.6666 7.3385ZM28.5358 14.4785C28.7199 15.286 28.8333 16.136 28.8333 17.0002C28.8333 23.2618 23.7616 28.3335 17.4999 28.3335C11.2383 28.3335 6.16659 23.2618 6.16659 17.0002C6.16659 10.7385 11.2383 5.66683 17.4999 5.66683C19.7383 5.66683 21.8066 6.3185 23.5633 7.43766L25.6033 5.39766C23.3083 3.78266 20.5174 2.8335 17.4999 2.8335C9.67992 2.8335 3.33325 9.18016 3.33325 17.0002C3.33325 24.8202 9.67992 31.1668 17.4999 31.1668C25.3199 31.1668 31.6666 24.8202 31.6666 17.0002C31.6666 15.3143 31.3549 13.6993 30.8166 12.1977L28.5358 14.4785Z",
    fill: "#00456F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmptyTask);
export default __webpack_public_path__ + "static/media/new_empty_task.5998fca920edabfb828a5caa72949c6c.svg";
export { ForwardRef as ReactComponent };